import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { match } from "@faedev/variant";
import Link from "next/link";
import { useRouter } from "next/router";
import { Button, Modal } from "react-bootstrap";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import VideoPlayer from "src/components/VideoPlayer";
import constants from "src/constants";
import getDataVideo from "src/functions/getDataVideo";
import getLink from "src/functions/getLink";
import translate from "src/functions/translate";
import Small_cancel from "src/icons/Small-cancel";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtonClose } from "src/styles/sButtonClose.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sModal } from "src/styles/sModal.module.scss";
import { sModalVideo } from "src/styles/sModalVideo.module.scss";
import { ApiVideoCard } from "src/types/ApiVideoCard";

type Props = {
  data: ApiVideoCard;
  openModalVideo: DynamicValue<boolean>;
};

function ModalVideo({ data, openModalVideo }: Props) {
  const { locale: lang } = useRouter();
  var dVideo = match(
    getDataVideo(String(data.video)).data,
    {
      loading: function (loading) {
        return null;
      },
      error: function (error) {
        return null;
      },
      success: function (success) {
        return success;
      },
    },
    function (type) {
      return null;
    }
  );
  return dVideo ? (
    <Modal
      show={openModalVideo.value}
      className={composeClassNames([sModal, sModalVideo, "modal-video"])}
      size="lg"
      onHide={() => openModalVideo.change(false)}
    >
      <Modal.Header>
        <Modal.Title>
          {withDefault(data.title, translate(`Play video`, lang))}
          {data.profile ? (
            <div className={"small"}>{data.profile.nickname}</div>
          ) : null}
        </Modal.Title>
        <Button
          variant="link"
          onClick={function () {
            return openModalVideo.change(false);
          }}
          size="sm"
          className={composeClassNames([sButtonClose, `btn-close`])}
        >
          <Small_cancel />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <VideoPlayer data={dVideo} thumbnail={data.thumbnail} />
        <Text size="nm" className={`video-label`}>
          {data.label}
        </Text>
      </Modal.Body>
      {dVideo.provider ? (
        <Modal.Footer>
          <div
            className={composeClassNames([
              sButtons,
              "buttons",
              "row",
              "align-center",
            ])}
          >
            <Button
              as="a"
              type="button"
              className={composeClassNames([sButton, "btn-social"])}
              variant="outline-primary"
              href={
                (function () {
                  switch (dVideo.provider.name) {
                    case `YouTube`:
                      return constants.Paths.providerYoutubeChannel;
                    case `Vimeo`:
                      return constants.Paths.providerVimeoChannel;
                  }
                })() + dVideo.provider.channel_id
              }
              target="_blank"
            >
              <Translate tKey={`Open the YouTube channel`} />
            </Button>
            {data.profile ? (
              <Link
                href={getLink(lang, `profile`, data.profile.url, null)}
                passHref
              >
                <Button
                  type="button"
                  as="a"
                  variant="primary"
                  className={composeClassNames([sButton, "btn-social"])}
                >
                  <Translate tKey={`Show instructor profile`} />
                </Button>
              </Link>
            ) : null}
          </div>
        </Modal.Footer>
      ) : null}
    </Modal>
  ) : null;
}

export default ModalVideo;
